"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklyDayPicker = void 0;
var WeeklyDayPicker_base_1 = require("./WeeklyDayPicker.base");
var WeeklyDayPicker_styles_1 = require("./WeeklyDayPicker.styles");
var Utilities_1 = require("../../Utilities");
exports.WeeklyDayPicker = (0, Utilities_1.styled)(WeeklyDayPicker_base_1.WeeklyDayPickerBase, WeeklyDayPicker_styles_1.styles, undefined, { scope: 'WeeklyDayPicker' });
//# sourceMappingURL=WeeklyDayPicker.js.map